var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._b({staticClass:"kd-button",class:[
    _vm.typeClassName,
    _vm.sizeClassName,
    _vm.roundClassName,
    _vm.arrowClassName,
    _vm.plainClassName,
    _vm.strokeClassName,
    _vm.borderClassName,
    _vm.disabledClassName,
    _vm.useDisabledMaskClassName,
  ],attrs:{"type":_vm.buttonType},on:{"click":_vm.onclick}},'button',_vm.$attrs,false),[(_vm.$slots.prefix)?_vm._t("prefix"):_vm._e(),_vm._t("default",function(){return [_vm._v("确定")]}),(_vm.$slots.suffix)?_vm._t("suffix"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }